import {useEffect, useCallback} from 'react';

type TKeyTyped = 'keydown' | 'keyup' | 'keypress';

// This hook created to fix the bug - https://prioritysoftware.atlassian.net/browse/EP-44242
export function useHandlePressKey({
    target = document,
    keyTyped = 'keypress',
    keyPressed = 'Enter',
    cb,
    isDropdownOpen,
    setIsDropdownOpen
}: {
    target?: HTMLElement | Document;
    keyTyped?: TKeyTyped;
    keyPressed?: string;
    cb?;
    isDropdownOpen?: boolean;
    setIsDropdownOpen?: (value: boolean) => void;
}): void {
    const handleKeyPress = useCallback(
        event => {
            const runFunc = () => {
                event.preventDefault();
                event.stopPropagation();
                cb?.(event);
            };
            // This is to prevent the default behavior of the Enter key in the editor and to stop the propagation of the event
            if (event.key === keyPressed) {
                if (isDropdownOpen) {
                    runFunc();
                    setIsDropdownOpen(false);
                    return;
                } else if (event.key === 'Escape') {
                    // This else condition is for bug - https://prioritysoftware.atlassian.net/browse/EP-44862
                    runFunc();
                    return;
                }
            }
        },
        [keyPressed, cb, isDropdownOpen]
    );

    useEffect(() => {
        target && target.addEventListener(keyTyped, handleKeyPress);

        return () => {
            target && target.removeEventListener(keyTyped, handleKeyPress);
        };
    }, [target, handleKeyPress]);

    return;
}
